<template>
  <div>
    <div class="card shadow-sm border-0">
      <div class="card-header bg-white">
        <div class="d-flex justify-content-between align-items-center">
          <h5>Categorías</h5>
          <AddCategory />
        </div>
      </div>
      <div class="card-body">
        <div v-if="!loading" class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead class="bg-dark text-white">
              <tr class="">
                <th></th>
							  <th>Posición</th>
                <th>Título</th>
                <th>Temática</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <draggable
              v-if="categories.length"
              v-model="categories"
              group="categories"
              item-key="UUID"
              @end="updateOrder"
              tag="tbody"
            >
              <template #item="{ element, index }">
                <CategoryRow :category="element" :position="index + 1" />
              </template>
            </draggable>
            <tbody v-else>
              <tr>
                <td colspan="6" class="text-center text-muted">No hay categorías disponibles.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div>Cargando información</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddCategory from "@/components/Blog/elements/Categories/AddCategory.vue";
import CategoryRow from "@/components/Blog/elements/Categories/CategoryRow.vue";
import CategoryService from "@/services/category.service.js";
import draggable from "vuedraggable";
import Swal from "sweetalert2";

export default {
  name: "Categories",
  components: {
    AddCategory: AddCategory,
    CategoryRow: CategoryRow,
    draggable,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      categories: [],
      loading: true,
      dragging: false,
    };
  },
  methods: {
    async start() {
      this.loading = true;
      await this.getCategories();
      this.loading = false;
    },
    async getCategories() {
      const response = await CategoryService.getAllCategories();
      this.categories = response.data.sort((a, b) => a.position - b.position);
    },
    async updateOrder() {
      try {
        Swal.fire({
          title: "Guardando...",
          text: "Por favor espera mientras se guarda el orden.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });

        for (let i = 0; i < this.categories.length; i++) {
          this.categories[i].position = i + 1;
        }

        const response = await CategoryService.updateCategoriesOrder(
          this.categories.map((c) => ({
            UUID: c.UUID,
            position: c.position,
          }))
        );

        Swal.close();

        if (response.status === 200) {
          await Swal.fire({
            icon: "success",
            title: "Orden actualizado",
            text: "El orden de las categorías se ha guardado correctamente.",
            confirmButtonColor: "#0091ff",
          });
        } else {
          throw new Error();
        }
      } catch (error) {
        Swal.close();
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al actualizar el orden.",
          confirmButtonColor: "#d33",
        });
      }
    },
  },
  created() {
    this.start();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>
